import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { ParameterEntity } from "../dto/parameter-entity";


@Injectable()
export class ParameterRepo extends Repository<ParameterEntity> {

    constructor(@InjectRepository(ParameterEntity) private parameterRepo: Repository<ParameterEntity>
    ) {
        super(parameterRepo.target, parameterRepo.manager, parameterRepo.queryRunner);
    }

}